export default __webpack_public_path__ + "static/media/SonoRecLogo.abe0dd2b.png";